import React, { useEffect, useState } from "react";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import {
  MainWrapper,
  PrimaryTab,
  PrimaryTabs,
  PrimaryTabsWrapper,
  StyledDivider,
  SubTab,
  SubTabs,
  SubTabsWrapper,
} from "../../citizen/AVPForms/components/StyledComponent";
import EmpTopBar from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/EmpTopBar";
import useEmpMapSubmission from "./useEmpMapSubmission";
import ViewDocuments from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/ViewDocuments";
// import ChatBoard from "../../../components/ChatBoard";
import AllRemarksList from "../../../../../templates/Forms/AllRemarks";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { formMTDocActions } from "@egovernments/digit-ui-module-core/src/redux/actions";
import NewsTicker from "@egovernments/digit-ui-module-core/src/pages/citizen/Home/TCP-HP/NewsTicker";
import SubStep1 from "../../citizen/AVPForms/formComponents/self-approval/Step1/SubStep1";
import SubStep3 from "../../citizen/AVPForms/formComponents/self-approval/Step1/SubStep3";
import SubStep2 from "../../citizen/AVPForms/formComponents/self-approval/Step1/SubStep2";
import SubStep4 from "../../citizen/AVPForms/formComponents/self-approval/Step1/SubStep4";
import Step3 from "../../citizen/AVPForms/formComponents/self-approval/Step3";
import PrimaryContent from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/PrimaryContent";
import CollapsibleHistory from "../NotingRemarks";
import OnSelectActionDropdown from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/OnSelectActionDropdown";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
import DocUploader from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/DocUploader";
import SubmitButton from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/SubmitButton";
import { siteInspRecommendation } from "../../citizen/TCPForms/data";
import DetailInfoTable from "../AllViewRemarks";
import RecommendationRemarksComponent from "../RecommendationComponent";
import PaymentMemoTable from "../AllViewRemarks/PaymentChallan/PaymentMemoDetails";
import PaymentHead from "./PaymentHead";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";
import ChallanDetails from "../AllViewRemarks/PaymentChallan/ChallanDetails";
import InitialChallanSelfApproval from "../AllViewRemarks/PaymentChallan/InitialChallanSelfApproval";
import "./EmpSelfApproval.css";
const EmpSelfApproval = ({ formData, refetch, submitAction, workflowDetails, userRolesArray, urlFormType }) => {
  const dispatch = useDispatch();
  const { initFormMTDocs } = bindActionCreators(formMTDocActions, dispatch);
  const [activeTab, setActiveTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_TAB") || 0);
  const [selectedSubTab, setSelectedSubTab] = useState(Digit?.SessionStorage.get("MS_CURRENT_SUBTAB") || 0);
  const [showToast, setShowToast] = useState(null);
  const [showCurrentChallan, setShowCurrentChallan] = useState(false);
  const isFeesEligible = ["AA", "AAP", "AP"].includes(userRolesArray?.[0]?.code);

  const {
    currentAction,
    isCitizen,
    t,
    actions,
    handleSubmit,
    error,
    setError,
    remarks,
    setRemarks,
    documentSection,
    setIsPreviewLoading,
    tenantId,
    params,
    taxHead,
    setTaxHead,
    iframeSrc,
    setIframeSrc,
    updateApiCall,
    initialUrl,
    developerRemarks,
    onSelect,
    Modal,
    isValidEmp,
    dataRecommendation,
    setDeveloperRemarks,
    callNotingDetailsAPI,
    uploadedFile,
    setUploadedFile,
    notingRemarksData,
    onDropDownSelect,
    setDataRecommendation,
    paymentHeadRemarksData,
    callPaymentDetailsAPI,
    mapSubmissionAction,
    isFromDashboard,
  } = useEmpMapSubmission(formData, refetch, workflowDetails, userRolesArray, urlFormType);
  // const isHideAction = ["REVERT_TO_APPLICANT", "APPROVED"]?.includes(formData?.status) && !isCitizen;
  const subTabLabels = [
    { label: "Application Information" },
    { label: "Plot Details" },
    { label: "Applicant Information" },
    { label: "Geo Location" },
    { label: "Fees" },
  ];
  const closeToast = () => {
    setShowToast(null);
  };

  useEffect(() => {
    if (formData?.documents?.length > 0) {
      initFormMTDocs(formData.documents);
    }
  }, []);
  const handleTabChange = async (nextTabNo) => {
    setActiveTab(nextTabNo);
    Digit.SessionStorage.set("MS_CURRENT_TAB", nextTabNo);
  };

  const handleSubTabChange = (nextSubTab) => {
    setSelectedSubTab(nextSubTab);
    Digit.SessionStorage.set("MS_CURRENT_SUBTAB", nextSubTab);
  };

  const renderContent = () => {
    console.log("activeTabFromRender", activeTab);
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return <SubStep1 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 1:
          return <SubStep2 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 2:
          return <SubStep3 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 3:
          return <SubStep4 formData={formData} handleSubTabChange={handleSubTabChange} isEmployee={!isCitizen} />;
        case 4:
          return (
            <React.Fragment>
              <PaymentHead
                tenantId={tenantId}
                formData={params}
                setTaxHead={setTaxHead}
                taxHead={taxHead}
                empRole={userRolesArray?.[0]?.code}
                isFeesEligible={isFeesEligible}
                onSelect={onSelect}
                Modal={Modal}
                isValidEmp={isValidEmp}
                setShowCurrentChallan={setShowCurrentChallan}
                isFromDashboard={isFromDashboard}
              />
              {/* {formData?.initialTaxHead && (
                <details className="emp-accordion">
                  <summary style={{ cursor: "pointer", fontWeight: 600 }}>Previous Challan</summary>
                  <div style={{ padding: "8px 0" }}>
                    <InitialChallanSelfApproval
                      formData={params}
                      taxHead={params?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.paymentHeads}
                      totalAmount={params?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.estimateAmount}
                    />
                  </div>
                </details>
              )} */}
              {/* <details className="emp-accordion">
                <summary style={{ cursor: "pointer", fontWeight: 600 }}>Current Challan</summary>
                <div style={{ padding: "8px 0" }}>
                  {showCurrentChallan ? (
                    <ChallanDetails
                      formData={params}
                      taxHead={params?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.paymentHeads}
                      totalAmount={params?.taxHeadEstimates?.[formData?.taxHeadEstimates?.length - 1]?.estimateAmount}
                    />
                  ) : (
                    <p style={{ padding: "8px 0" }}>No Challan Generated</p>
                  )}
                </div>
              </details> */}
              <PaymentMemoTable formData={params} />
              <RecommendationRemarksComponent
                title="Recommendation Details"
                label="Recommendation"
                name="recommendation" // just a field name, not value!
                options={SortingAlphabatically(siteInspRecommendation)}
                defaultValue={dataRecommendation}
                extraLabel="Remarks"
                setDeveloperRemarks={setDeveloperRemarks}
                developerRemarks={developerRemarks}
                setDataRecommendation={setDataRecommendation}
                buttonshow={true}
                onSaveClick={callPaymentDetailsAPI} // <-- parent callback
                isFromDashboard={isFromDashboard}
              />
              <DetailInfoTable detailData={paymentHeadRemarksData?.DetailDataRemarks} type="paymentDetails" />
            </React.Fragment>
          );
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return (
        <React.Fragment>
          <ViewDocuments
            documentSection={documentSection}
            setIsPreviewLoading={setIsPreviewLoading}
            iframeSrc={iframeSrc}
            setIframeSrc={setIframeSrc}
            initialUrl={initialUrl}
          />
        </React.Fragment>
      );
    } else if (activeTab === 2) {
      return (
        <React.Fragment>
          <PrimaryContent formData={formData} handleChange={handleTabChange} serviceName={"Map Submission"} />
          <CollapsibleHistory
            formData={formData}
            callNotingDetailsAPI={callNotingDetailsAPI}
            developerRemarks={developerRemarks}
            setDeveloperRemarks={setDeveloperRemarks}
            notingRemarksData={notingRemarksData}
          />

          <OnSelectActionDropdown currentAction={currentAction || mapSubmissionAction || " "} onChange={onDropDownSelect} actions={actions} />
          <RemarksEditor setRemarks={setRemarks} remarks={remarks} setError={setError} error={error} />
          <DocUploader uploadedFile={uploadedFile} setUploadedFile={setUploadedFile} />
          {actions?.length > 0 && !isFromDashboard && <SubmitButton handleSubmit={handleSubmit} isLoading={updateApiCall.isLoading} />}
        </React.Fragment>
      );
    } else if (activeTab === 3) {
      return (
        <React.Fragment>
          <AllRemarksList remarkDataResps={workflowDetails?.data} />
        </React.Fragment>
      );
    }
    // else if (activeTab === 4) {
    //   return (
    //     <React.Fragment>
    //       <ChatBoard formData={formData} assignerToChatboard={workflowDetails?.data?.processInstances} />
    //     </React.Fragment>
    //   );
    // }
  };

  return (
    <MainWrapper>
      {/* <HeaderContent applicationFlow={applicationFlow} /> */}
      <BackButton />
      <EmpTopBar formData={formData} />
      <NewsTicker textForNews="Important: The following sections are mandatory - Document Section, Site Inspection Report and Payment Head. Please ensure all details are filled accordingly." />
      <PrimaryTabsWrapper>
        {/* Tabs Header */}
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="fullWidth">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Take Action" />
          <PrimaryTab label="All Remarks" />
          <PrimaryTab label="Chat Board" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      <StyledDivider />
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            setIsPreviewLoading={setIsPreviewLoading}
            setIframeSrc={setIframeSrc}
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default EmpSelfApproval;
